import "@/state";

import { bootstrapJotai } from "./jotai";

export const jotaiStore = bootstrapJotai();
